module.exports = {"513434100":"越城镇","513434101":"中所镇","513434102":"新民镇","513434103":"乃托镇","513434104":"普雄镇","513434105":"大瑞镇","513434106":"竹阿觉镇","513434107":"书古镇","513434108":"依洛地坝镇","513434109":"南箐镇","513434110":"贡莫镇","513434111":"梅花镇","513434112":"尔觉镇","513434113":"拉普镇","513434114":"马拖镇","513434115":"大花镇","513434116":"板桥镇","513434211":"保安藏族乡","513434235":"拉吉乡","513434236":"申果庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513434.json
// module id = 2575
// module chunks = 0